@use '../../styling/badges.scss' as *;
@use '../../styling/colors.scss' as *;

.GitStatusBadge {
  @extend %badge-base;

  min-width: 100px; //Incomplete is the longest
  white-space: nowrap;
  border: 2px solid $color-highlight-blue;

  &.SUCCESS {
    border-color: $color-primary-green;
    color: $color-primary-green;
  }

  &.ERROR {
    border-color: $color-primary-red;
    color: $color-primary-red;
  }

  &.PENDING {
    border-color: $color-grey-B;
    color: $color-grey-B;
  }
}
